import { Collection } from 'lib/documents/document';
import { useReducer } from 'lib/hooks/useReducer';
import { useEffect } from 'react';
import {
  QuestionnaireControlSliceReducer,
  initialState,
  questionnaireInfoInitialLoad
} from '../assessment/assessment-controller/questionnaire-control-flow-slice';

export function useGetQuestionnaireInfo(patientId: string) {
  const [state, dispatch] = useReducer(
    QuestionnaireControlSliceReducer,
    initialState
  );

  /**
   * Load data patient data
   */
  useEffect(
    () => {
      dispatch(
        questionnaireInfoInitialLoad({
          patientId,
          rootPath: Collection.PendingPatientAssessments
        })
      );
    },
    // eslint-disable-next-line
    [patientId]
  );

  return { state, dispatch };
}
